// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
measuringDeviceCertificationCalculation) => (
{
  ...measuringDeviceCertificationCalculation,
  sum: convertFromRubToKop(measuringDeviceCertificationCalculation.sum),
  months: measuringDeviceCertificationCalculation.months.map(
    convertDataToServerMeasuringDeviceCertificationCalculationMonth
  )
});

export const convertDataFromServer = (
measuringDeviceCertificationCalculation) => (
{
  ...measuringDeviceCertificationCalculation,
  sum: convertFromKopToRub(measuringDeviceCertificationCalculation.sum),
  months: measuringDeviceCertificationCalculation.months.map(
    convertDataFromServerMeasuringDeviceCertificationCalculationMonth
  )
});

export const convertDataToServerMeasuringDeviceCertificationCalculationMonth = (
measuringDeviceCertificationCalculationMonth) => (
{
  ...measuringDeviceCertificationCalculationMonth,
  cost: convertFromRubToKop(measuringDeviceCertificationCalculationMonth.cost)
});

export const convertDataFromServerMeasuringDeviceCertificationCalculationMonth = (
measuringDeviceCertificationCalculationMonth) => (
{
  ...measuringDeviceCertificationCalculationMonth,
  cost: convertFromKopToRub(measuringDeviceCertificationCalculationMonth.cost)
});

const basedUrl = 'measuringDeviceCertificationCalculation';
const measuringDeviceCertificationCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в тарировке цистерн',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...measuringDeviceCertificationCalculation,
  calculate,
  changeStatus,
  print
};
